import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Layout from '../components/Layout'
import Header from '../components/Cognito/Shared/Header'
import Footer from '../components/Cognito/Shared/Footer'
import { useLoginBackground } from 'hooks/useLoginBackground'
import Skeleton from '../components/Shared/Skeleton'
import MFAChallenge from 'components/Cognito/MFA/Challenge/MFAChallenge'
import { useCognito } from 'components/Cognito/CognitoContextProvider'
import useIsFirstRender from 'hooks/useFirstRender'
import PostAuthenticatorSetup from 'components/Cognito/MFA/Setup/PostAuthenticatorSetup'

const MFA = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const user = useSelector((state) => state.user)
  const { challenge: { session } } = useCognito()
  const firstRender = useIsFirstRender()
  const bgImage = useLoginBackground({ reuseLast: true })

  useEffect(() => {
    if (!firstRender) return

    if (!session) {
      history.replace('/login')
    }
  }, [history, session, firstRender])

  return (
    <Layout title={t('Login.mfa.completeLogin')}>
      <Helmet bodyAttributes={{ class: 'authentication-page login-page' }} />
      <div className="login-page-wrapper">
        <Header showBack={false} />
        <main className="mfa-form mb-0" data-cy="login-form-cy">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-lg">
                <div className="login-content">
                  {!user.isLogged && <MFAChallenge />}
                  {user.isLogged && <PostAuthenticatorSetup />}
                  <Footer />
                </div>
              </div>
              <div
                className="col-lg-auto d-none d-lg-block px-lg-0 image-col"
                style={{ 
                  backgroundImage: `url('${bgImage.loading ? '' : bgImage.url}')`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundColor: '#e9ecef'
                }}
              >
                <Skeleton isLoading={bgImage.loading} />
              </div>
            </div>
          </div>
        </main>
      </div>
    </Layout>
  )
}

export default MFA
